import { ICloneable } from '../../../contracts/cloneable.js';
import { IDataComparable } from '../../../contracts/data-comparable.js';
import { ArgumentException } from '../../../exceptions/argument-exception.js';
import { DatabaseIdGenerator } from '../../../utility/database-id-generator.js';
import { isNotNullOrUndefined } from '../../../utility/null-safety.js';
import { SeatOrderType } from './seat-order-type.js';
import { SeatState } from './seat-state.js';

const ALLOWED_ORDER_ID_LENGTH = DatabaseIdGenerator.kAutoIdLength;

export class SeatInfo implements IDataComparable, ICloneable {
  private _orderId: string | null;

  constructor(
    public readonly uniqueId: number,
    public state: SeatState,
    public orderType: SeatOrderType,
    orderId: string | null,
  ) {
    if(isNotNullOrUndefined(orderId) && orderId.length !== ALLOWED_ORDER_ID_LENGTH) {
      throw new ArgumentException('orderId', `Order ID length must be ${ALLOWED_ORDER_ID_LENGTH} characters, but it is ${orderId.length} characters ${orderId}`);
    }

    this._orderId = orderId;
  }

  get orderId(): string | null {
    return this._orderId;
  }

  set orderId(value: string | null) {
    if(isNotNullOrUndefined(value) && value.length !== ALLOWED_ORDER_ID_LENGTH) {
      throw new ArgumentException('orderId', `Order ID length must be ${ALLOWED_ORDER_ID_LENGTH} characters, but it is ${value.length} characters ${value}`);
    }

    this._orderId = value;
  }

  static free(seatId: number): SeatInfo {
    return new SeatInfo(
        seatId,
        SeatState.Free,
        SeatOrderType.None,
        null,
    );
  }

  clone(): this {
    return new SeatInfo(
        this.uniqueId,
        this.state,
        this.orderType,
        this.orderId,
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.uniqueId === this.uniqueId &&
        other.state === this.state &&
        other.orderType === this.orderType &&
        other.orderId === this.orderId;
  }
}
